import { Validators } from '@angular/forms';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';

export const investment_isp_form_template = {
  amount: '0',
};

export const investment_isp_form_validators = {
  amount: [Validators.required, Validators.pattern(/^\d+(\,\d+)?$/)],
};

export const INVESTMENT_LIFE_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
  {
    key: 'description',
    label: 'Nome fondo',
  },
  {
    key: 'amount',
    label: 'Importo da investire',
  },
];

export const INVESTMENT_PREVIDENTIAL_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
  {
    key: 'description',
    label: 'Nome fondo',
  },
  //   {
  //     key: 'quoteNumber',
  //     label: 'Numero Quote',
  //   },
  {
    key: 'currentInvestedValue',
    label: 'Importo fondo (€)',
  },
  {
    key: 'quoteValue',
    label: 'Quotazione',
  },
  {
    key: 'quoteValueUpdateDate',
    label: 'Data Nav',
  },
  {
    key: 'pInvestment',
    label: 'Percentuale di Investimento (%)',
  },
];

export interface ISwitchLifeInvestmentsRequest {
  policyNumber: string;
  investmentFunds: InvestmentFund[];
  totalAmountToTransfer: number;
  currentValue: string;
  ndgTutoreODelegato?: string;
  codiceLineaCompagnia?: string[];
  controvaloreLineaCompagnia?: string[];
  consultancyAmount?: string;
}

export interface InvestmentFund {
  code: string;
  fundCurrentAmount: number;
  movementAmount: number;
  currentPercentage: number;
  isInvestment: boolean;
}

export interface ISwitchPrevidentialInvestmentsRequest {
  policyNumber: string;
  investmentRequest: PrevidentialInvestmentMovement;
}

export interface PrevidentialInvestmentMovement {
  cFondoDA: string;
  descrizione: string;
  tipoClasse?: string
  fondoA: PrevidentialInvestedFund[];
}
export interface PrevidentialInvestedFund {
  c_compagnia: string;
  c_fondo: string;
  c_garanzia: string;
  descrizione: string;
  p_investimento: string;
  c_tipo_classe?: string
}
